export default __webpack_public_path__ + "static/O0278-7cbf6aca5df3614cfa80d17f702ca748.png";